import React, { useEffect } from 'react';
import { useState } from 'react';
import OverviewCareer from "@/components/overview-career";
import ApplicationCareer from "@/components/application-career";
import { CardSkeleton } from './card-skeleton';

export default function ApplyCareer({careerId}) {
    const [activeTab, setActiveTab] = useState('overview');
    const [careers, setCareers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCareerById = async () => {
          try {
            const response = await fetch(`/api/careers/${careerId}`);
            if (!response.ok) {
              setLoading(false);
              throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setCareers(data);
            setLoading(false);
          } catch (error) {
            setLoading(false);
            console.error('Failed to fetch careers:', error);
          }
        };
    
        fetchCareerById();
      }, [careerId]);


      console.log(careers);


    return (
      <>
        {loading && <CardSkeleton />}
        <div className="flex flex-col md:flex-row max-w-4xl mx-auto p-4 gap-4">
            <div className="w-100 md:w-40 flex-shrink-0 p-2 md:p-6 bg-white border rounded-lg">
                <h2 className="text-xl font-bold mb-4">Job Details</h2>
                <p className='my-2 text-sm'>Salary:<br/> {careers.salary}</p><hr/>
                <p className='my-2 text-sm'>Min. Experience: <br/>{careers.exp}</p><hr/>
                <p className='my-2 text-sm'>Location: <br/> Remote</p><hr/>
                <p className='my-2 text-sm'>Job Type: <br/> Full Time</p>
            </div>

            <div className="w-100 md:w-60 p-4 md:p-6 bg-white border rounded-lg">
            <div className="flex justify-center mb-2 gap-4">
                    <button 
                        onClick={() => setActiveTab('overview')} 
                        className={`text-lg outline-none font-medium ${activeTab === 'overview' ? 'text-black' : 'text-gray-500'}`}
                    >
                        Overview
                    </button>
                    <button 
                        onClick={() => setActiveTab('application')} 
                        className={`text-lg outline-none font-medium ${activeTab === 'application' ? 'text-black' : 'text-gray-500'}`}
                    >
                        Application
                    </button>
                </div><hr className='mb-4'/>
                
                {activeTab === 'overview' ? <OverviewCareer careerDesc={careers} loading={loading} /> : <ApplicationCareer careerDesc={careers}/>}
            </div>
        </div>
        </>
    );
}
